import type { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from "axios";

const OB_KEY = "openbetRequestAge";

const getEndpointName = (url: string | undefined) => {
    return url?.split("/").pop();
};

const persistRequestAge = (response: AxiosResponse) => {
    const name = getEndpointName(response.config.url);
    const date = response.headers["x-created-at"];
    if (!name || !date) return;
    const openbetRequestAge = JSON.parse(localStorage.getItem(OB_KEY) || "{}");
    const newOpenbetRequestAge = {
        ...openbetRequestAge,
        [name]: date,
    };
    // TODO: Replace later with some more suitable place rather than local storage if needed
    localStorage.setItem(OB_KEY, JSON.stringify(newOpenbetRequestAge));
};

const setRequestAge = (config: InternalAxiosRequestConfig) => {
    const openbetRequestAge = JSON.parse(localStorage.getItem(OB_KEY) || "{}");
    const name = getEndpointName(config.url);
    if (!name) return;
    const lastRequestAge = openbetRequestAge[name];
    if (lastRequestAge) {
        config.headers.set("If-Modified-Since", lastRequestAge);
    }
};

const requestDateInterceptor = (config: InternalAxiosRequestConfig) => {
    // Add date of the last request if there is any, otherwise skip (which is ok if this is the first call)
    setRequestAge(config);
    return config;
};

const responseDateInterceptor = (response: AxiosResponse) => {
    // Save date of the request which will be used during the next call
    persistRequestAge(response);
    return response;
};

export const addIfModifiedSinceHeaderInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(requestDateInterceptor);
    httpClient.interceptors.response.use(responseDateInterceptor);
};
